import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78fdc8fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vulnerability-info-wrap" }
const _hoisted_2 = { class: "leak-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeakView = _resolveComponent("LeakView")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LeakView, {
        "terminal-info": _ctx.terminalInfo,
        "is-terminal-info": "",
        onAuthSuccess: _ctx.handleAuthSuccess
      }, null, 8, ["terminal-info", "onAuthSuccess"])
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}